import { ArrowLeft } from 'iconsax-react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import v1 from '../../assets/images/v1.svg';
import v2 from '../../assets/images/v2.svg';
import v3 from '../../assets/images/v3.svg';
import v4 from '../../assets/images/v4.svg';
import v5 from '../../assets/images/v5.svg';
import v6 from '../../assets/images/v6.svg';
import v7 from '../../assets/images/v7.svg';
import Text from '../../assets/styles/Text';
import * as styles from './styles';

export default function Verification({ v, back = true }) {
  const navigate = useNavigate();

  function verifNumber(number) {
    switch (number) {
      case 1:
        return <img src={v1} alt="v1" />;
      case 2:
        return <img src={v2} alt="v2" />;

      case 3:
        return <img src={v3} alt="v3" />;

      case 4:
        return <img src={v4} alt="v4" />;

      case 5:
        return <img src={v5} alt="v5" />;

      case 6:
        return <img src={v6} alt="v5" />;

      case 7:
        return <img src={v7} alt="v5" />;

      default:
        return null;
    }
  }

  function handleBack() {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/modelregister');
    }
  }

  return (
    <styles.Container>
      <styles.GroupImg>{verifNumber(v)}</styles.GroupImg>

      {back && (
        <styles.Button onClick={handleBack}>
          <ArrowLeft />
          <Text.P $bold>Voltar</Text.P>
        </styles.Button>
      )}
    </styles.Container>
  );
}

Verification.propTypes = {
  v: PropTypes.number.isRequired,
  back: PropTypes.bool,
};
